"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.firstWarningMessage = exports.hasWarning = exports.firstErrorMessage = exports.hasError = void 0;

var _constants = require("./constants");

var hasError = function hasError() {
  var notifications = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return notifications.some(function (alert) {
    return alert.type === _constants.ALERT_TYPE_ERROR || alert.severity === _constants.ALERT_TYPE_ERROR;
  });
};

exports.hasError = hasError;

var firstErrorMessage = function firstErrorMessage() {
  var notifications = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var alert = notifications.find(function (notification) {
    return notification.type === _constants.ALERT_TYPE_ERROR || notification.severity === _constants.ALERT_TYPE_ERROR;
  });
  return alert ? alert.message : '';
};

exports.firstErrorMessage = firstErrorMessage;

var hasWarning = function hasWarning() {
  var notifications = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return notifications.some(function (alert) {
    return alert.type === _constants.ALERT_TYPE_WARNING || alert.severity === _constants.ALERT_TYPE_WARNING;
  });
};

exports.hasWarning = hasWarning;

var firstWarningMessage = function firstWarningMessage() {
  var notifications = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var alert = notifications.find(function (notification) {
    return notification.type === _constants.ALERT_TYPE_WARNING || notification.severity === _constants.ALERT_TYPE_WARNING;
  });
  return alert ? alert.message : '';
};

exports.firstWarningMessage = firstWarningMessage;
//# sourceMappingURL=utils.js.map